<template>
  <v-dialog
      v-model="dialog"
      persistent
      :max-width="maxWidth || 400"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          :disabled="disabled"
          :color="color" dark
          v-bind="attrs"
          v-on="on"
      >
        <span>{{ title }}</span>
      </v-btn>
    </template>

    <slot name="body" :dialog="dialog">
      <v-card>
        <v-card-title class="headline">
          {{ title }}
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="formValid">
            <v-select
                @change="setObject"
                :items="products"
                v-model="tmpProduct"
                item-text="Name"
                item-value="Id"
                return-object
                outlined dense
                :rules="[required]"
                label="Выбрать товар"/>
            <v-text-field :rules="[negative,number]" type="number" v-model="terminalLog.Tons" outlined dense
                          label="Количество в тоннах"/>
            <v-text-field :rules="[required]" v-model="terminalLog.Comment" outlined dense label="Комментарий"/>
          </v-form>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="green darken-1"
              text
              @click="unSetObject"
          >
            Отменить
          </v-btn>
          <v-btn
              color="green darken-1"
              text
              @click="accept"
          >
            Подтвердить
          </v-btn>
        </v-card-actions>
      </v-card>
    </slot>

  </v-dialog>

</template>

<script>
export default {
  name: "OilModal",
  props: {
    title: String,
    maxWidth: String,
    products: Array,
    IsWriteOff: Boolean,
    disabled: Boolean,
    color: String,
    action: Function
  },
  data() {
    return {
      negative: (value) => {
        if (!this.IsWriteOff) return true
        const tons = this.tmpProduct.Tons - parseFloat(this.terminalLog.Tons)
        if (tons < 0) return 'У продукта неможет быть объём меньше нуля'
        return true
      },
      number(value) {
        const numb = parseFloat(value)
        if (isNaN(numb)) return 'Можно вести только числа'
        return true
      },
      required(value) {
        return !!value || 'Это поля не может быть пустым'
      },
      dialog: false,
      terminalLog: {
        ProductId: '',
        ProductName: '',
        Tons: '',
        IsWriteOff: this.IsWriteOff,
        Comment: '',
      },
      tmpProduct: {},
      formValid: false,
    }
  },
  methods: {
    setObject(product) {
      this.terminalLog.ProductId = product.Id
      this.terminalLog.ProductName = product.Name
    },
    unSetObject() {
      this.terminalLog = {
        ProductId: '',
        ProductName: '',
        Tons: '',
        IsWriteOff: this.IsWriteOff,
        Comment: ''
      }
      this.tmpProduct = {}
      this.dialog = false
    },
    accept() {
      this.$refs.form.validate()
      if (!this.formValid) {
        return
      }
      if (!this.IsWriteOff) {
        this.tmpProduct.Tons = this.tmpProduct.Tons || 0
        this.tmpProduct.Tons += parseFloat(this.terminalLog.Tons)
      } else {
        this.tmpProduct.Tons -= parseFloat(this.terminalLog.Tons)
      }
      this?.action(this.terminalLog)
      this.unSetObject()
    }
  }
}
</script>